import { Component } from '@angular/core';

@Component({
  selector: 'app-department-stock',
  standalone: false,
  
  templateUrl: './department-stock.component.html',
  styles: ``
})
export class DepartmentStockComponent {

}
